import {
  FETCH_COMMERCIAL_TYPES,
  FETCH_COMMERCIAL_TYPES_SUCCESS,
  FETCH_COMMERCIAL_TYPES_FAILED,
  EDIT_COMMERCIAL_TYPE
} from "../store/types";

const INITIAL_STATE = {
  commercialtypes:  {

    commercialtypes: [], 
    message:null
    
  },
  loading: false,
  error: {
    flag: false,
    msg: null
  }
}

export const commercialtypesreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_COMMERCIAL_TYPES:
      return {
        ...state,
        loading: true
      };
    case FETCH_COMMERCIAL_TYPES_SUCCESS:
      return {
        ...state,
        commercialtypes: action.payload,
        loading: false
      };
    case FETCH_COMMERCIAL_TYPES_FAILED:
      return {
        ...state,
        commercialtypes: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case EDIT_COMMERCIAL_TYPE:
      return state;
    default:
      return state;
  }
};